import React, {FC} from "react"
import Flex from "@irati/ui/src/Flex"
import {H3, Label} from "@irati/ui/src/Typography"
import Card from "@irati/ui/src/Layout/Card"
import mainTheme from "@irati/ui/src/global/theme"
import {FormattedMessage} from "@irati/utils/lang"

const ExplorePremiumContent: FC = () => (
  <Card small bgColor={mainTheme.colors.utility.ink} marginTop={5}>
    <Flex marginTop>
      <H3 color={mainTheme.colors.greys.white}>
        <FormattedMessage id="wellness.rentalMedia.explorePremiumContent.title" />
      </H3>
    </Flex>
    <Label color={mainTheme.colors.greys.white} display="block" large marginTop={2} marginBottom={2}>
      <FormattedMessage id="wellness.rentalMedia.explorePremiumContent.body" />
    </Label>
    {/* todo: uncomment button when premium category will be available */}
    {/* <Button inverted marginBottom> */}
    {/*  <FormattedMessage id="wellness.rentalMedia.explorePremiumContent.cta" /> */}
    {/* </Button> */}
  </Card>
)

export default ExplorePremiumContent
